// extracted by mini-css-extract-plugin
module.exports = {"root":"AddCategory_root__iOmwg","addCategoryForm":"AddCategory_addCategoryForm__3R438"};